import React from 'react';

import StatusBox from 'pages/LiveClassroom/components/StatusBox/index';
import {
  STATUS_TO_COLOR_MAPPER,
  STATUS_TO_ICON_MAPPER
} from 'pages/LiveClassroom/constants';

import styles from './style.module.scss';

const ClassroomStatuses = ({ studentData }) => (
  <div className={styles.container}>
    {Object.entries(studentData).map(([key, item], index) => (
      <StatusBox
        key={index}
        color={STATUS_TO_COLOR_MAPPER[key]}
        number={item.length}
        status={key.replaceAll('_', ' ')}
        icon={STATUS_TO_ICON_MAPPER[key]}
      />
    ))}
  </div>
);

export default ClassroomStatuses;
